<form [formGroup]="form" class="form" *ngIf="form">
  <div class="form-body">
    <div class="form-section">
      <app-form-row [label]="['FORMS.PASSWORD.CURRENT_PASSWORD'] | translateControl : form | async">
        <app-input [type]="'password'" [mainForm]="form" [controlName]="'currentPassword'">
        </app-input>
      </app-form-row>
      <app-form-row [label]="['FORMS.PASSWORD.NEW_PASSWORD'] | translateControl : passwordForm | async">
        <app-input-password [mainForm]="passwordForm" [controlName]="'newPassword'" [layoutMod]="['password']">
        </app-input-password>
      </app-form-row>
      <app-form-row [label]="['FORMS.PASSWORD.CONFIRM_PASSWORD'] | translateControl : passwordForm | async">
        <app-input [type]="'password'" [mainForm]="passwordForm" [controlName]="'confirmPassword'">
        </app-input>
      </app-form-row>
    </div>
  </div>
</form>
